module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"consultation":"Consultation"},"fr":{"consultation":"Consultation"}}')
  delete Component.options._Ctor
}
